import React, { Component } from 'react'

export default class Documentation extends Component {
    render() {
        return (
            <div className='doc'>
                <div className="doc__inner">
                <div className="about__text_container">
                    <div className="text_container_left">
                        <p className="title">Документация</p>
                        <p className="subtitle">Все команды тут</p>
                    </div>
                    <div className="text__container_right">
                        <p className="text">Документация поможет тебе разобратся как работает и как <br></br> использовать ту или иную команду</p>
                    </div>
                </div>
                <div className="line purple"></div>
                    <div className="doc__doc_container">
                        <div className="doc__text_container">
                            <p className="doc__comand">Информация о элементе</p>
                            <p className="doc__desc">Чтобы получить информацию о любом элементе нужно написать боту его название</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">Азот</p>
                        </div>
                        <div className="doc__text_container">
                            <p className="doc__comand">Информация о кислотах</p>
                            <p className="doc__desc">Чтобы получить информацию о кислотах нужно написать боте команду "кислоты"</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">Кислоты</p>
                        </div>
                        <div className="doc__text_container">
                            <p className="doc__comand">Информация о химических связях</p>
                            <p className="doc__desc">Чтобы получить информацию химических связях нужно написать боте команду "химические связи"</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">Химические связи</p>
                        </div>
                        <div className="doc__text_container">
                            <p className="doc__comand">Информация об остатках</p>
                            <p className="doc__desc">Чтобы получить информацию о остатках нужно написать боте команду "остатки"</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">Остатки</p>
                        </div>
                        <div className="doc__text_container">
                            <p className="doc__comand">Получить ряд активности металлов</p>
                            <p className="doc__desc">Чтобы посмотреть ряд активности металлов нужно написать боте команду "ряд активности металлов"</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">Ряд активности металлов</p>
                        </div>
                        <div className="doc__text_container">
                            <p className="doc__comand">Информация о солях</p>
                            <p className="doc__desc">Чтобы получить информацию о солях нужно написать боте команду "соли"</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">Соли</p>
                        </div>
                        <div className="doc__text_container">
                            <p className="doc__comand">Информация о полимерах</p>
                            <p className="doc__desc">Чтобы получить информацию о полимерах нужно написать боте команду "полимеры"</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">Полимеры</p>
                        </div>
                        <div className="doc__text_container">
                            <p className="doc__comand">Информация о углеводах</p>
                            <p className="doc__desc">Чтобы получить информацию о углеводах нужно написать боте команду "углеводы"</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">Углеводы</p>
                        </div>
                        <div className="doc__text_container">
                            <p className="doc__comand">Информация о галогенах</p>
                            <p className="doc__desc">Чтобы получить информацию о галогенах нужно написать боте команду "галогены"</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">Галогены</p>
                        </div>
                        <div className="doc__text_container">
                            <p className="doc__comand">Информация о жирах</p>
                            <p className="doc__desc">Чтобы получить информацию о жирах нужно написать боте команду "жиры"</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">Жиры</p>
                        </div>
                        <div className="doc__text_container">
                            <p className="doc__comand">Информация о белках</p>
                            <p className="doc__desc">Чтобы получить информацию о белках нужно написать боте команду "белки"</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">Белки</p>
                        </div>
                        <div className="doc__text_container">
                            <p className="doc__comand">Сбалансировать решенное уравнение</p>
                            <p className="doc__desc">Чтобы сбалансировать решенное химическое уравнение нужно использовать команду "balance", для правельной работы команды важно соблюдать пробелы между элементами и знаками как в примере использования</p>
                            <p className="doc__article">Использование</p>
                            <p className="doc__desc">balance H2 + O2 -> H20</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
